import dayjs from "dayjs";
import { useEffect, useState } from "react";
import Picker from "react-mobile-picker-scroll";
import { ModalBottom } from "../ModalBottom";

const years = Array.from({ length: 100 }, (_, i) => 1950 + i); // 1950~2049
const months = Array.from({ length: 12 }, (_, i) => i + 1); // 1~12
const days = Array.from({ length: 31 }, (_, i) => i + 1); // 1~31

// UI에 쓸 라벨 배열 (옵션용)
const yearOptions = years.map((n) => `${n}년`);
const monthOptions = months.map((n) => `${n}월`);
const dayOptions = days.map((n) => `${n}일`);

// 라벨 생성/파싱 유틸
const toLabel = (name: "year" | "month" | "day", v: number) =>
  name === "year" ? `${v}년` : name === "month" ? `${v}월` : `${v}일`;

const parseNumber = (label: string) =>
  parseInt(label.replace(/[^\d]/g, ""), 10);

const hours = Array.from({ length: 12 }, (_, i) =>
  String(i + 1).padStart(2, "0")
); // "01" ~ "12"

const mins = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0")); // "00" ~ "59"

const dayNight = Array.from(["오전", "오후"]);

interface ModalBase {
  data: any;
  title: string;
  onClose: () => void;
}

interface ModalWithDate extends ModalBase {
  time?: false;
  onConfirm: (y: number, m: number, d: number) => void;
}

interface ModalWithTime extends ModalBase {
  time: true;
  onConfirm: (y: string, m: string, d: string) => void;
}

type ModalProps = ModalWithDate | ModalWithTime;

export const ModalDatePicker = ({
  data,
  title,
  onClose,
  onConfirm,
  time,
}: ModalProps) => {
  const today = dayjs();
  const y = today.year(); // 1998
  const m = today.month() + 1; // 0~11이므로 +1, 결과 3
  const d = today.date();

  const [year, setYear] = useState<number>(() =>
    Number(data.split(".")[0] || y)
  );
  const [month, setMonth] = useState<number>(() =>
    Number(data.split(".")[1] || m)
  );
  const [day, setDay] = useState<number>(() => Number(data.split(".")[2] || d));

  const [hour, setHour] = useState<string>(() => String(data.split(" ")[1]));
  const [min, setMin] = useState<string>(() => String(data.split(" ")[3]));
  const [dayNights, setDayNights] = useState<string>(() =>
    String(data.split(" ")[0])
  );

  // ✅ body 스크롤 잠금
  useEffect(() => {
    const preventScroll = (e: TouchEvent) => e.preventDefault();
    document.body.style.overflow = "hidden";
    document.addEventListener("touchmove", preventScroll, { passive: false });
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", preventScroll);
    };
  }, []);

  return (
    <>
      <ModalBottom title={title} onClose={onClose} onRow={true}>
        <>
          {/* 중앙 선택 Picker */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              gap: 8,
              fontSize: "18px",
            }}
          >
            {time ? (
              <Picker
                optionGroups={{ hour: hours, min: mins, dayN: dayNight }}
                valueGroups={{ hour: hour, min: min, dayN: dayNights }}
                onChange={(date: string, value: string) => {
                  if (date === "hour") setHour(value);
                  if (date === "min") setMin(value);
                  if (date === "dayN") setDayNights(value);
                }}
                itemHeight={48}
              />
            ) : (
              <Picker
                optionGroups={{
                  year: yearOptions,
                  month: monthOptions,
                  day: dayOptions,
                }}
                valueGroups={{
                  year: toLabel("year", year),
                  month: toLabel("month", month),
                  day: toLabel("day", day),
                }}
                onChange={(name: string, value: string) => {
                  const num = parseNumber(value); // "yyyy년" -> yyyy
                  if (name === "year") setYear(num);
                  if (name === "month") setMonth(num);
                  if (name === "day") setDay(num);
                }}
                itemHeight={48}
              />
            )}
          </div>

          {/* 확인 버튼 */}
          <div
            style={{
              height: 48,
              background: "#F57C00",
              borderRadius: 8,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              color: "white",
              fontWeight: 500,
              fontSize: 16,
            }}
            onClick={() => {
              if (time) {
                onConfirm(hour, min, dayNights); // string 3개
              } else {
                onConfirm(year, month, day); // number 3개
              }
            }}
            // onClick={() => onConfirm(hour, min, day)}
          >
            확인
          </div>
        </>
      </ModalBottom>
    </>
  );
};
